module.exports = __webpack_public_path__ + "static/media/Rectangle 2.b47b4a67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Curators/Rectangle 2.jpg
// module id = 181
// module chunks = 0